<template>
  <div class="box">
    <div class="loading-spinner-outer" v-if="loading">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
      </div>
    </div>
    <div class="box-content">
      <div class="flex-2xs justify-end">
          <div class="pr-3-2xs mb-1 mb-0-2xs">
            <select class="form-control" v-model="company_type_filter">
              <option value="" v-if="company_type_filter === ''">Filter ...</option>
              <option value="" v-else> Clear Filter</option>
              <option value="1">Fabricator</option>
              <option value="2">Installer</option>
              <option value="3">Trade Counter</option>
              <option value="4">Other</option>
            </select>
          </div>
          <div>
            <input type="text" placeholder="Search" class="form-control" v-model="search_query">
          </div>
      </div>
      <template v-if="!loading && total_count > 0">
        <table class="table_list">
          <thead>
          <tr>
            <th>Date Registered</th>
            <th>Company Name</th>
            <th>Company Type</th>
            <th>Email</th>
            <th></th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(registration_request, index) in registration_requests">
            <td>{{ registration_request.formatted_created_at }}</td>
            <td><a :href='"/registration-request/"+registration_request.id'>{{
                registration_request.company_name
              }}</a></td>
            <td>{{ registration_request.company_type.label }}</td>
            <td>
                <div class="flex break-all">
                    <i class="fal fa-times txt-danger pr-2" v-show="!registration_request.is_verified"></i>
                    <i class="fal fa-check txt-positive pr-2" v-show="registration_request.is_verified"></i>
                    {{ registration_request.email }}
                </div>
            </td>
            <td class="td_delete">
              <a class="txt-danger cursor-pointer" @click.prevent="denyRequest(registration_request.id)">
                <i class="fa fa-trash"></i>
              </a>
            </td>
            <td class="td_view">
              <a :href='"/registration-request/"+registration_request.id' class="txt-primary">
                <i class="fa fa-eye"></i>
              </a>
            </td>
          </tr>
          </tbody>
        </table>
        <template>
          <div class="pagination-bar wrapper mb-3 mt-3">
            <div class="row">
              <div class="col">
                <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                    class="fa fa-caret-left"></i></a>
                <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                   class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
              </div>
              <div class="col align-right">
                <div class="mt-1 mb-1">
                  {{ total_count }} results found
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-if="!loading && total_count === 0">
        <strong>
          No Results Found
        </strong>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    if(window.location.hash) {
      this.current_page = window.location.hash.substring(1);
    }
    this.loadFeed();
  },
  data() {
    return {
      registration_requests: [],
      search_query: '',
      current_page: 1,
      company_type_filter: '',
      total_count: 0,
      total_pages: 0,
      limit: 20,
      loading: true,
    }
  },
  methods: {
    loadFeed: _.debounce(function () {
      axios.post('/registration-request/getRegistrationRequests', {
        page_number: this.current_page,
        search_query: this.search_query,
        company_type_filter: this.company_type_filter,
        limit: this.limit
      }).then((response) => {
        this.registration_requests = response.data.data;
        this.total_count = response.data.total;
        this.total_pages = response.data.last_page;
        this.loading = false;
      });
    }, 250),
    prevPage() {
      this.current_page = this.current_page - 1;
      this.setPageHash();
      this.loadFeed();
    },
    nextPage() {
      this.current_page = this.current_page + 1;
      this.setPageHash();
      this.loadFeed();
    },
    denyRequest(id) {
      Swal.fire({
        title: 'Are you sure you want to deny this request?',
        text: 'This action cannot be undone.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = `/registration-request/deny/${id}`;
        }
      });
    },
    setPageHash() {
      window.location = `#${this.current_page}`;
    }
  },
  watch: {
    search_query() {
      this.current_page = 1;
      this.setPageHash();
      this.loadFeed();
    },
    company_type_filter() {
      this.current_page = 1;
      this.setPageHash();
      this.loadFeed();
    },
  },
};
</script>
